import { GroupId } from '../../typings/groups';

export const DROP_INTERNAL_GROUPS_FIELD_VALIDATION_ERRORS = 'DROP_INTERNAL_GROUPS_FIELD_VALIDATION_ERRORS';
export type DROP_INTERNAL_GROUPS_FIELD_VALIDATION_ERRORS = typeof DROP_INTERNAL_GROUPS_FIELD_VALIDATION_ERRORS;

export interface InternalGroupsFieldValidationErrorsDropAction {
    type: DROP_INTERNAL_GROUPS_FIELD_VALIDATION_ERRORS;
    groupId: GroupId;
    fieldName: string;
}

export function dropInternalGroupsFieldValidationErrors(
    groupId: GroupId,
    fieldName: string
): InternalGroupsFieldValidationErrorsDropAction {
    return {
        type: DROP_INTERNAL_GROUPS_FIELD_VALIDATION_ERRORS,
        groupId,
        fieldName
    };
}
